if (!customElements.get("cart-feedback")) {
  customElements.define("cart-feedback", class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toast = this.querySelector("[data-cart-toast]");
      this.querySelector("[data-cart-toast-close]")?.addEventListener("click", () => this.hideToast(), options);
      this.querySelector("[data-cart-toast-cart]")?.addEventListener("click", () => {
        const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
        if (typeof cart?.open !== "function") return;
        this.hideToast();
        cart.open(document.getElementById("cart-icon-bubble"));
      }, options);
      this.toast?.addEventListener("mouseenter", () => this.pauseToast(), options);
      this.toast?.addEventListener("mouseleave", () => this.scheduleToastDismiss(), options);
      this.toast?.addEventListener("focusin", () => this.pauseToast(), options);
      this.toast?.addEventListener("focusout", () => queueMicrotask(() => this.scheduleToastDismiss()), options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.pauseToast();
      this.toastAnimation?.cancel();
    }
    show() {
      this.pauseToast();
      this.animateToast(true);
    }
      pauseToast() {
        clearTimeout(this.toastTimer);
      }

      animateToast(show) {
        this.toastAnimation?.cancel();
        if (!this.toast) return;
        this.toastClosing = !show;
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (show) this.toast.hidden = false;
        if (reduced) {
          this.toast.hidden = !show;
          if (show) this.scheduleToastDismiss();
          return;
        }
        const visible = { opacity: 1, transform: "translate(-50%, 0)" };
        const below = { opacity: 0, transform: "translate(-50%, calc(100% + 3rem))" };
        const animation = this.toast.animate(show ? [below, visible] : [visible, below], {
          duration: show ? 280 : 220,
          easing: show ? "cubic-bezier(0.16, 1, 0.3, 1)" : "ease-in",
          fill: "both",
        });
        this.toastAnimation = animation;
        animation.finished.then(() => {
          if (this.toastAnimation !== animation) return;
          this.toast.hidden = !show;
          animation.cancel();
          this.toastAnimation = null;
          if (show) this.scheduleToastDismiss();
        }).catch(() => {});
      }

      hideToast() {
        this.pauseToast();
        if (this.toast && !this.toast.hidden) this.animateToast(false);
      }

      scheduleToastDismiss() {
        this.pauseToast();
        if (!this.toast || this.toast.hidden || this.toastClosing || this.toast.matches(":hover") ||
            this.toast.contains(document.activeElement)) return;
        const duration = Number(this.dataset.duration || 5);
        this.toastTimer = setTimeout(() => this.hideToast(), (Number.isFinite(duration) && duration > 0 ? duration : 5) * 1000);
      }

  });
}
{
  // Internal phases only. Keep present(cart, response, source) synchronous/void.
  function resolvePresentation(source) {
    const feedback = document.querySelector("cart-feedback");
    let modes = {};
    try {
      const parsed = JSON.parse(feedback?.dataset.modes || "{}");
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) modes = parsed;
    } catch (_) {
      // Missing/invalid configuration keeps the existing drawer fallback.
    }
    const toast = Object.prototype.hasOwnProperty.call(modes, source) && modes[source] === "toast" &&
      typeof feedback?.show === "function" && Boolean(feedback.querySelector("[data-cart-toast]"));
    return { feedback, toast };
  }

  function updateCart(cart, response, toast) {
    if (typeof cart?.renderContents !== "function" || !response?.sections ||
        typeof response.sections !== "object" || Array.isArray(response.sections)) return;
    // renderContents owns drawer opening (including timing/focus); preserve its boolean contract.
    return cart.renderContents(response, !toast);
  }

  function showFeedback(feedback, toast) {
    if (toast) return feedback.show();
  }

  function runPhase(action, phase) {
    try {
      const pending = action();
      if (pending && typeof pending.then === "function") {
        Promise.resolve(pending).catch(error => console.error(`CartFeedback: ${phase}`, error));
      }
    } catch (error) {
      // The cart POST belongs to the caller and is never repeated here.
      console.error(`CartFeedback: ${phase}`, error);
    }
  }

  window.CartFeedback = {
    present(cart, response, source) {
      const { feedback, toast } = resolvePresentation(source);
      runPhase(() => updateCart(cart, response, toast), "falha ao atualizar carrinho");
      runPhase(() => showFeedback(feedback, toast), "falha ao apresentar feedback");
    },
  };
}
